module.exports = "<router-outlet></router-outlet>\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = 418
// module chunks = 1